namespace Portico.Services {

	import pme = Portico.Models.Enterprise;
	import psga = apigateway.client;
    import Inject = Portico.Decorators.Inject;
    import Service = Portico.Decorators.Service;

    export interface IPrescriptionService {
		getByAccountId(programId: number, accountId: number): angular.IPromise<pme.Prescription[]>;
		getNdcList: (programId: number) => angular.IPromise<pme.Ndc[]>;
		populate(programId: number, account: pme.Account): angular.IPromise<boolean>;
    }

    @Service('app', 'prescriptionService')
	@Inject('$q', 'PrescriptionV1Api')
    export class PrescriptionService implements IPrescriptionService {
        constructor(
            private $q: angular.IQService,
			private prescriptionV1Api: psga.PrescriptionV1Api
        ) { }

		getByAccountId(programId: number, accountId: number): angular.IPromise<pme.Prescription[]> {
			// TODO: wrap in an edge call
			return this.$q.when(this.prescriptionV1Api.accountPrescriptionGet(accountId.toString(), programId.toString(), '5').then((response) => {
				const temp: pme.Prescription[] = [];

				for (let prescription of response.data.data) {
					temp.push(new pme.Prescription(prescription));
				}

				return temp;
			}));
		}

		getNdcList(programId: number): angular.IPromise<pme.Ndc[]> {
			//let ndcList: pme.Ndc[] = this.storageService.getItem<pme.Ndc[]>(pm.StorageType.Session, `ndc-${programId}-list`);

			const promise = //ndcList ?
				//this.$q.when(ndcList) :
				this.$q.when(this.prescriptionV1Api.programIdByProgramId('', '').then((response: any) => {
					return response.data.Data;
				}));

			return promise.then((response: pme.Ndc[]) => {
				const temp: pme.Ndc[] = [];

				for (const ndc of response) {
					temp.push(new pme.Ndc(ndc));
				}

				//this.storageService.saveItem<pme.Ndc[]>(pm.StorageType.Session, `ndc-${programId}-list`, temp);

				return temp;
			});
		}

		populate(programId: number, account: pme.Account): angular.IPromise<boolean> {
			return this.getByAccountId(programId, account.id).then((prescriptions) => {
				account.prescriptions = prescriptions;
				return true;
			});
		}
    }
}